<div class="flex flex-col flex-col-reverse md:flex-row md:gap-8">
  <div class="md:w-[30%] w-full">
    <p class="md:text-3xl text-xl md:mb-12 mb-8 text-center mt-4">
      Welcome to our Partner Portal
    </p>
    <app-load-spinner-wrapper [loading]="loading">
      <p class="md:text:xl text-lg mb-2">Set Your New Password</p>
      <p class="text-sm mb-2">You need to set a new password before accessing your account.</p>
      <form [formGroup]="form" class="flex flex-wrap gap-4 mt-8">
        <mat-form-field class="w-full" appearance="fill">
          <mat-label>New Password</mat-label>
          <input matInput type="password" formControlName="password">
          @if (form.get('password')?.hasError('required')) {
            <mat-error>
              Password is required.
            </mat-error>
          }
          @if (form.get('password')?.hasError('passwordPolicy')) {
            <mat-error>
              Min 10 chars, with upper, lower, number & symbol.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full" appearance="fill">
          <mat-label>Confirm New Password</mat-label>
          <input matInput type="password" formControlName="confirmPassword">
          @if (form.get('confirmPassword')?.hasError('required')) {
            <mat-error>
              Confirm new password is required.
            </mat-error>
          }
          @if (form.get('confirmPassword')?.hasError('passwordMismatch')) {
            <mat-error>
              Passwords do not match.
            </mat-error>
          }
        </mat-form-field>
        <button
          mat-raised-button
          class="mt-4 !bg-green w-full mb-8"
          (click)="setNewPassword()">
          <p class="text-sm lg:text-lg text-base">Set New Password</p>
        </button>
      </form>
      <a [routerLink]="['/portal-login']" class="underline">Back</a>
    </app-load-spinner-wrapper>
  </div>
  <div class="md:w-[70%] w-full">
    <img
      src="assets/images/partnerPortalLoginImage.png"
      alt="Partner Portal"
      class="w-full h-auto">
  </div>
</div>
